import { useState } from "react";

const usePopupState = () => {
  // "view", "edit", "close" 세 가지 상태를 가지는 팝업의 커스텀 훅.
  // view: 팝업이 열리고 읽기모드의 상태.
  // edit: 팝업이 열리고 수정모드의 상태.
  // close: 팝업이 닫힌 상태.
  const [mode, setMode] = useState("close");

  const setPopupOpen = () => {
    setMode("view");
  };
  const setPopupEdit = () => {
    setMode("edit");
  };
  const setPopupClose = () => {
    setMode("close");
  };

  return { mode, setPopupClose, setPopupEdit, setPopupOpen };
};

export default usePopupState;
